import React from "react";
import { useParams } from "react-router-dom";
import SolutionsBuilderLandingPage from "./SolutionsBuilderLandingPage";

export default function CreateSolutionPage() {
  const { solutionUuid } = useParams<{ solutionUuid: string }>();
  return <SolutionsBuilderLandingPage solutionUuid={solutionUuid} />;
}
